<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />
    </div> -->
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="box">
      <v-toolbar flat dense class="toolbar">
        <v-toolbar-title>Self Appraisal Authority Type</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
      </v-toolbar>
      <v-data-table :headers="headers" :items="authority_type_list" class="elevation-1 mytable" dense :search="search">
        <template v-slot:top>
          <v-toolbar flat dense color="white">
            <!-- <v-toolbar-title>Fees Component</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider> -->
            <v-spacer></v-spacer>
            <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details>
            </v-text-field>
            <span style="width: 20px"></span>
            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on }">
                <v-btn class="button" v-on="on">Add Authority Type</v-btn>
              </template>
              <v-card>
                <v-card-title class="toolbar">
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-row>


                      <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1">
                        <v-autocomplete dense rounded outlined :items="authority_type_super_master_list"
                          v-model="addedItem.authority_type" label="Select Authority Type"></v-autocomplete>
                      </v-col>
                      <v-col cols="12" sm="12" md="12" v-if="editedIndex != -1">
                        <v-text-field v-model="editedItem.authority_type" dense rounded outlined persistent-hint
                          :disabled="editedIndex != -1" :hint="
                            editedIndex == -1
                              ? 'For example :: MCQ, Subjective'
                              : 'noneditable'
                          " label="Authority Type"></v-text-field>
                      </v-col>

                      <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1">
                        <v-autocomplete dense rounded outlined :items="level_number_list" v-model="addedItem.level_no"
                          label="Select Level"></v-autocomplete>
                      </v-col>
                      <v-col cols="12" sm="12" md="12" v-if="editedIndex != -1">
                        <v-autocomplete dense rounded outlined :items="level_number_list" v-model="editedItem.level_no"
                          label="Select Level"></v-autocomplete>
                      </v-col>

                      <!-- <v-col cols="12" sm="6" md="4" v-if="editedIndex != -1">
                        <v-checkbox
                          dense
                          v-model="editedItem.isactive"
                          color="success"
                          label="Active"
                        ></v-checkbox>
                      </v-col> -->
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn class="button" @click="close">Cancel</v-btn>
                  <v-btn class="button" @click="save">Save</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>

        <!-- <template v-slot:item.compulsory="{ item }">
          <v-switch
            inset
            v-model="item.compulsory"
            :color="item.compulsory ? 'success' : 'primary'"
            @change="toggle(item)"
          ></v-switch>
        </template> -->

        <template v-slot:item.islast="{ item }">
          <v-switch v-model="item.islast" inset color="success" @change="makeLast(item)"></v-switch>
        </template>
        <template v-slot:item.isactive="{ item }">
          <v-switch v-model="item.isactive" inset color="success" @change="statusToggle(item)"></v-switch>
        </template>
        <template v-slot:item.donotconsiderincalculation="{ item }">
          <v-switch v-model="item.donotconsiderincalculation" inset color="success" @change="SkipValueToggle(item)"></v-switch>
        </template>

        <template v-slot:item.action="{ item }">
          <div>
            <v-avatar style="" size="25" class="edit-avatar">
              <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
            </v-avatar>
          </div>
          <!-- <v-icon
        small
        @click="deleteItem(item)"
      >
        delete
      </v-icon> -->
        </template>
        <!-- <template v-slot:no-data>
      <v-btn color="primary" @click="initialize">Reset</v-btn>
    </template> -->
      </v-data-table>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },
  data: () => ({
    overlay: false,
    errorMsg: {
      authority_type: false,
    },
    snackbar_msg: "",
    color: "",
    snackbar: false,
    // extraBreadcrumbItems: [
    //   { text: "Appraisal Authority Type", disabled: true, href: "" },

    // ],
    // breadcrumbClass: "breadcrumb-style1",
    search: "",
    dialog: false,
    authority_type_super_master_list: null,
    headers: [
      {
        text: "Authority Type",
        align: "left",
        sortable: false,
        value: "authority_type",
      },
      {
        text: "Level Number",
        align: "left",
        sortable: true,
        value: "level_no",
      },
      {
        text: "Is last ?",
        align: "left",
        sortable: true,
        value: "islast",
      },
      {
        text: "Skip in Calculation ?",
        align: "left",
        sortable: true,
        value: "donotconsiderincalculation",
      },
      {
        text: "Is Active ?",
        align: "left",
        sortable: true,
        value: "isactive",
      },
      { text: "Actions", value: "action", sortable: false },
    ],
    authority_type_list: [],
    level_number_list: [],
    editedIndex: -1,
    addedItem: {
      authority_type: null,
      level_no: null,
    },
    editedItem: {
      id: "",
      authority_type: "",
      level_no: null
    },
    defaultItem: {
      id: "",
      authority_type: "",
      level_no: null,
    },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? "New Authority Type"
        : "Edit Authority Type";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    overlay(val) {
      val = () => {
        this.overlay = false;
      };
    },
  },

  // created () {
  //   this.initialize()
  // },
  mounted() {
    this.onLoad();
  },
  methods: {
    initializeErrorMsgFalse() {
      this.errorMsg.authority_type = false;
    },
    onLoad() {
      this.overlay = true;
      axios
        .post("/SelfAppriasalMaster/appriasalAuthorityType")
        .then((res) => {
          if (res.data.msg == "200") {
            this.overlay = false;
            this.authority_type_super_master_list =
              res.data.authority_type_super_master_list;
            this.authority_type_list = res.data.authority_type_list;
            this.level_number_list = res.data.level_no_list;
            this.donotconsiderincalculation = res.data.donotconsiderincalculation;
            this.load = true;
          } else {
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          window.console.log(error);
        })
        .finally(() => {
          
          "use strict";
          var overlay = false;
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },

    editItem(item) {
      this.editedIndex = this.authority_type_list.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
        
      if (this.editedIndex > -1) {
        if (this.isValidated()) {
          axios
            .post("/SelfAppriasalMaster/editAppriasalAuthorityType",this.editedItem)
            .then((res) => {
              if (res.data.flag == "YES") {
                this.showSnackbar(
                  "#4caf50",
                  res.data.snackabar
                ); // show snackbar on success
              }else{
                  this.showSnackbar("#b71c1c", res.data.snackabar);
              }
              this.onLoad();
            })
            .catch((error) => {
              window.console.log(error);
              this.showSnackbar("#b71c1c","Something went wrong!!!");
            })
            .finally(() => {
              
            });

          this.close();
        }
      } else {
          if (this.addedItem.authority_type == null) {
              this.showSnackbar("#b71c1c","Please select Authority Type!!!");
              return false
          }
          if (this.addedItem.level_no == null) {
              this.showSnackbar("#b71c1c","Please select Level Number!!!");
              return false
          }
        axios
          .post("/SelfAppriasalMaster/saveAppriasalAuthorityType", this.addedItem)
          .then((res) => {
            if (res.data.flag == "YES") {
              this.authority_type_list.push(this.addedItem);
              this.showSnackbar(
                "#4caf50",
                 res.data.snackabar
              ); // show snackbar on success
              this.onLoad();
            } else if (res.data.flag == "NO") {
              this.showSnackbar(
                "#b71c1c",
                res.data.snackabar
              ); // show snackbar on error
            }
          })
          .catch((error) => {
            window.console.log(error);
            this.showSnackbar(
                  "#b71c1c",
                  "Something went wrong!!!"
                );
          })
          .finally(() => {
              this.addedItem.authority_type = null
            });

        this.close();
      }
    }, // end of save()

    makeLast(item){
        if (confirm("Are you sure!")) {
        const formData = {
          id: item.id,
          islast: item.islast
        };
        axios
          .post("/SelfAppriasalMaster/makeAuthorityLast", formData)
          .then((res) => {
            if (res.data.flag == "YES") {
              this.showSnackbar(
                "#4caf50",
                 res.data.snackabar
              ); // show snackbar on success
              this.onLoad();
            } else if (res.data.flag == "NO") {
              this.showSnackbar(
                "#b71c1c",
                res.data.snackabar
              ); // show snackbar on error
            }
          })
          .catch((error) => {
            window.console.log(error);
            this.showSnackbar(
                  "#b71c1c",
                  "Something went wrong!!!"
                );
          })
          .finally(() => {
              this.addedItem.authority_type = null
            });
        }
    },
    statusToggle(item) {
            const data = {
                section_id: item.id,
                toggle: item.isactive,
            };
            this.overlay = true;
            axios
                .post("/SelfAppriasalMaster/toggleAppraisalAuthority", data)
                .then((res) => {
                    this.overlay = false;
                    if (res.data.code == "SUCCESS") {
                        this.showSnackbar("success", "Appraisal Authority Type Status Changed Successfully !"); 
                    } else if (res.data.code == "NA") {
                        this.showSnackbar("error", "Something went wrong...");
                    }
                })
                .catch((error) => {
                    this.overlay = false;
                    this.showSnackbar("error", "Something went wrong");
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
    SkipValueToggle(item) {
      const data = {
          section_id: item.id,
          toggle: item.donotconsiderincalculation,
      };
      this.overlay = true;
        axios
            .post("/SelfAppriasalMaster/toggleSkipValue", data)
            .then((res) => {
                this.overlay = false;
                if (res.data.code == "SUCCESS") {
                  const message = item.donotconsiderincalculation
                    ? "Value will now be considered in calculation."
                    : "Value will now be excluded from calculation.";
                  this.showSnackbar("success", message);
                } else if (res.data.code == "NA") {
                    this.showSnackbar("error", "Something went wrong...");
                }
            })
            .catch((error) => {
                this.overlay = false;
                this.showSnackbar("error", "Something went wrong");
            })
            .finally(() => {
                this.overlay = false;
            });
    },
    isValidated() {
      if (this.editedItem.authority_type) {
        return true;
      } else {
        if (!this.editedItem.authority_type) {
          this.errorMsg.authority_type = true;
        }

        return false;
      }
    }, // .....end of isValidated()
  },
};
</script>
<style scoped>
.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}
.v-icon-size {
  font-size: 20px;
}
.edit-avatar {
  transition: 0.3s;
  border: 1px solid #b0bec5;
}
.edit-avatar:hover {
  background-color: #b0bec5;
}
.edit-v-icon {
  padding-left: 6px;
  font-size: 15px;
}
.edit-v-icon:hover {
  color: white;
}
.mytable /deep/ thead th {
  background: #0f2027 !important; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to right,
    #2c5364,
    #203a43,
    #0f2027
  ) !important; /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(
    to right,
    #2c5364,
    #203a43,
    #0f2027
  ) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  background-color: #0f2027 !important;
  color: white !important;
  font-weight: bold !important;
  white-space: nowrap !important;
  text-align: center;
}
</style>
